module.exports = __webpack_public_path__ + "static/media/confirm-delivery.be79e0cb.svg";